// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2qyvD","actions":"GroupTable_actions__N46kf","deleteModalFooter":"GroupTable_deleteModalFooter__3E6L-"};